export const colors = {
  black: '#1A1A1A',
  blackLight: '#1F1F1F',
  white: '#FFF',
  layoutBackground: '#F2F2F2',
  tileBackground: '#ECEEE9',
  footerBackground: '#1A1A1A',
  grey: '#F3F6F9',
  primary: '#00A4FF',
  brown: '#4E4143',
} as const
